/**
 * 인사관리 > 조직관리 페이지
 */

import React from 'react';

export function HrOrgPage() {
  return (
    <div>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--color-gray-800)', marginBottom: '16px' }}>
        인사관리 &gt; 조직관리
      </h1>
      <p style={{ color: 'var(--color-gray-600)' }}>
        조직관리 페이지입니다. 개발 예정입니다.
      </p>
    </div>
  );
}
